import MenuIcon from "@material-ui/icons/Menu";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import StarIcon from "@material-ui/icons/Star";
import HomeIcon from "@material-ui/icons/Home";
import FilterNoneOutlinedIcon from "@material-ui/icons/FilterNoneOutlined";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import LockIcon from "@material-ui/icons/Lock";
import MovieIcon from "@material-ui/icons/Movie";
import { Roles } from "../../../util/PermissionProvider";

// const menu = [
//   {
//     name: "Menu",
//     path: "/cinefan/menu",
//     icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//   },
//   {
//     name: "Programmes & Periods",
//     path: "/cinefan/programmes",
//     key: "programme",
//     icon: <VideoLibraryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//     children: [
//       {
//         name: "Programmes",
//         path: "/cinefan/programmes",
//       },
//       {
//         name: "Periods",
//         path: "/cinefan/period",
//       },
//     ],
//   },
//   { divider: true },
// ];

const menu = [
  {
    name: "Menu",
    path: "/cinefan/menu",
    icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "News",
    path: "/cinefan/news",
    icon: <InsertDriveFileIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Programmes & Periods",
    path: "/cinefan/programmes",
    key: "programme",
    icon: <VideoLibraryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    children: [
      {
        name: "Programmes",
        path: "/cinefan/programmes",
      },
      {
        name: "Periods",
        path: "/cinefan/period",
      },
    ],
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Movies",
    path: "/cinefan/movies",
    key: "movies",
    icon: <MovieIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    children: [
      {
        name: "All Movies",
        path: "/cinefan/movies",
      },
      {
        name: "Movie Tags",
        path: "/cinefan/movies/tags",
      },
      {
        name: "Movie Note",
        path: "/cinefan/movies/notes",
      },
    ],
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Remarks",
    path: "/cinefan/remarks",
    icon: <StarIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Homepage",
    path: "/cinefan/homepage",
    icon: <HomeIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Pages",
    path: "/cinefan/pages",
    icon: (
      <FilterNoneOutlinedIcon
        fontSize="small"
        style={{ color: "#BCBCBC", transform: "rotate(90deg)" }}
      />
    ),
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Profile",
    path: "/cinefan/profile",
    icon: <PersonIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "Options",
    path: "/cinefan/options",
    icon: <SettingsIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.CINEFAN_EDITOR,
      Roles.CINEFAN_VIEWER,
    ],
  },
  {
    name: "User Permission",
    path: "/cinefan/permission",
    icon: <LockIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN],
  },
];

export default menu;
